const Questions = {};

const containersSelector = `[questions-container]`;
const hiddenQuestionsSelector = `[hidden-questions]`;
const showHiddenButton = `[show-hidden]`;
const hideHiddenButton = `[hide-hidden]`;

/**
 * Retourne l'ensemble des conteneurs de questions
 * @returns {unknown[]}
 */
const getAllContainers = () => {
    return Array.from(document.querySelectorAll(containersSelector));
};

/**
 * Retourne le bouton d'affichage des questions cachées d'un conteneur
 * @param container
 * @returns {*}
 */
const getShowHiddenButton = (container) => {
    return container.querySelector(showHiddenButton);
};

/**
 * Retourne le bouton de masquage des questions cachées d'un conteneur
 * @param container
 * @returns {*}
 */
const getHideHiddenButton = (container) => {
    return container.querySelector(hideHiddenButton);
};

/**
 * Retourne les questions cachées d'un conteneur
 * @param container
 * @returns {*}
 */
const getHiddenQuestions = (container) => {
    return container.querySelector(hiddenQuestionsSelector);
}

/**
 * Ouvre les questions cachées d'un conteneur
 * @param container
 * @param button
 */
const openHiddenQuestions = (container, button) => {
    getHiddenQuestions(container).classList.remove('hidden');
    button.classList.add('hidden');

    getHideHiddenButton(container)?.classList.remove('hidden');
};

/**
 * Ferme les questions cachées d'un conteneur
 * @param container
 * @param button
 */
const closeHiddenQuestions = (container, button) => {
    getHiddenQuestions(container).classList.add('hidden');
    button.classList.add('hidden');

    getShowHiddenButton(container)?.classList.remove('hidden');
};

/**
 * Méthode d'initialisation des questions
 */
Questions.init = () => {
    getAllContainers().forEach(container => {
        getShowHiddenButton(container)?.addEventListener('click', (e) => {
            openHiddenQuestions(container, e.target);
        });

        getHideHiddenButton(container)?.addEventListener('click', (e) => {
            closeHiddenQuestions(container, e.target);
        });
    });
};

// Initialisation du script
if (window.acf) {
    window.acf.addAction('render_block_preview/type=questions-block', Questions.init());
    window.acf.addAction('render_block_preview/type=last-questions-block', Questions.init());
} else {
    Questions.init();
}
